import React from "react";
import {createRoot} from "react-dom/client";
import App from "./App";
import '@fontsource-variable/nunito/index.css'
import '@fontsource-variable/unbounded/index.css'
import "./normalize.css";
import "./index.css";
import './i18n';

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
    <App/>
);
